// jQuery must be on window before any legacy script or jQuery-UI module runs.
// Imported first by the bundle entries so its assignments happen before the
// other imports evaluate.
import $ from 'jquery'

window.$ = window.jQuery = $
